import React, { useState, useEffect } from 'react'

import './Images.scss'
import { ImageType, IMAGE_RATIO_HEIGHT, IMAGE_RATIO_WIDTH } from 'types'
import { getElementById, isIOSAndPWA } from 'utils'

export interface ImagesStyle {
  width: number | string
  height: number | string
  left?: number | string
}

interface Props {
  images: ImageType[]
  currentNum: number
}

const FRAME_ID = 'frame'

const DEFAULT_INCREMENT_SIZE = 5
let pesudoImagesSize = DEFAULT_INCREMENT_SIZE

export const Images = (props: Props) => {
  const { images, currentNum } = props
  const [imageStyle, setImageStyle] = useState<ImagesStyle | undefined>(undefined)
  const imagesSize = images.length

  if (currentNum >= pesudoImagesSize / 2 && currentNum < imagesSize) {
    pesudoImagesSize += DEFAULT_INCREMENT_SIZE
    if (pesudoImagesSize > imagesSize) pesudoImagesSize = imagesSize
  }

  const renderImages = () => {
    const returnImages = []
    for (let i = 0; i < pesudoImagesSize; i++) {
      returnImages.push(
        <div key={images[i].id} id={images[i].id} className={'img'} style={images[i].style} />
      )
    }
    return returnImages
  }

  // frame(window)のサイズに合わせて、Image(ルック)のサイズを調整する
  const adjustImageRatio = () => {
    const frameHeight = getElementById(FRAME_ID).clientHeight
    const frameWidth = getElementById(FRAME_ID).clientWidth
    const imageWidth = Math.round((frameHeight / IMAGE_RATIO_HEIGHT) * IMAGE_RATIO_WIDTH)
    let left = 0

    if (frameWidth < imageWidth) {
      const sideSpace = imageWidth - frameWidth
      left = -(sideSpace / 2)
    }

    setImageStyle({
      width: imageWidth,
      height: frameHeight,
      left: left === 0 ? '' : Math.round(left),
    })
  }

  useEffect(() => {
    let unmounted = false

    ;(async () => {
      if (!unmounted) {
        adjustImageRatio()

        isIOSAndPWA()
          ? window.addEventListener('orientationchange', adjustImageRatio)
          : window.addEventListener('resize', adjustImageRatio)
      }
    })()

    return () => {
      unmounted = true

      isIOSAndPWA()
        ? window.removeEventListener('orientationchange', adjustImageRatio)
        : window.removeEventListener('resize', adjustImageRatio)
    }
  }, [])

  return (
    <div id="images" className="images" style={imageStyle}>
      {renderImages()}
    </div>
  )
}
